var _circle, _rect, _rect2, _line, _line2, _text, _rect3, _line3, _line4, _text2, _rect4, _line5, _line6, _text3, _rect5, _line7, _line8, _text4, _rect6, _line9, _line0, _text5, _rect7, _line1, _line10, _text6, _circle2, _rect8, _rect9, _rect0, _text7, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartLoadManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 180,
    fill: "#FEF3C7",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 140,
    width: 240,
    height: 140,
    rx: 8,
    fill: "#3B82F6",
    opacity: 0.2,
    stroke: "#2563EB",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 160,
    width: 70,
    height: 70,
    rx: 4,
    fill: "#F59E0B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 160,
    x2: 135,
    y2: 230,
    stroke: "#D97706",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 195,
    x2: 170,
    y2: 195,
    stroke: "#D97706",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 205,
    fontSize: 24,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "1")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 160,
    width: 50,
    height: 60,
    rx: 4,
    fill: "#10B981"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 160,
    x2: 210,
    y2: 220,
    stroke: "#059669",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 190,
    x2: 235,
    y2: 190,
    stroke: "#059669",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 200,
    fontSize: 20,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "2")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 160,
    width: 50,
    height: 50,
    rx: 4,
    fill: "#EF4444"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 275,
    y1: 160,
    x2: 275,
    y2: 210,
    stroke: "#DC2626",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 185,
    x2: 300,
    y2: 185,
    stroke: "#DC2626",
    strokeWidth: 2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 275,
    y: 192,
    fontSize: 18,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "3")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 245,
    width: 55,
    height: 50,
    rx: 4,
    fill: "#8B5CF6"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 127.5,
    y1: 245,
    x2: 127.5,
    y2: 295,
    stroke: "#7C3AED",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 270,
    x2: 155,
    y2: 270,
    stroke: "#7C3AED",
    strokeWidth: 2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 127.5,
    y: 278,
    fontSize: 18,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "4")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 235,
    width: 45,
    height: 45,
    rx: 4,
    fill: "#EC4899"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 192.5,
    y1: 235,
    x2: 192.5,
    y2: 280,
    stroke: "#DB2777",
    strokeWidth: 2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 257.5,
    x2: 215,
    y2: 257.5,
    stroke: "#DB2777",
    strokeWidth: 2
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 192.5,
    y: 265,
    fontSize: 16,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "5")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 225,
    width: 70,
    height: 55,
    rx: 4,
    fill: "#06B6D4"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 265,
    y1: 225,
    x2: 265,
    y2: 280,
    stroke: "#0891B2",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 252.5,
    x2: 300,
    y2: 252.5,
    stroke: "#0891B2",
    strokeWidth: 2
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 265,
    y: 260,
    fontSize: 18,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "6")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 100,
    r: 30,
    fill: "#FFFFFF",
    stroke: "#2563EB",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 105,
    width: 20,
    height: 2,
    fill: "#2563EB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 110,
    width: 10,
    height: 15,
    fill: "#2563EB",
    opacity: 0.6
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 110,
    width: 10,
    height: 15,
    fill: "#2563EB"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 95,
    fontSize: 12,
    fill: "#2563EB",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "KG")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 60 200 L 75 200",
    stroke: "#10B981",
    strokeWidth: 3,
    markerEnd: "url(#arrowgreen)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrowgreen",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#10B981"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartLoadManagement);
export default __webpack_public_path__ + "static/media/part-load-management.23d94ed358eb003fc6a5207d09f56597.svg";
export { ForwardRef as ReactComponent };